import { PipeTransform } from '@angular/core';
var CreditCardNumberPipe = /** @class */ (function () {
    function CreditCardNumberPipe() {
    }
    CreditCardNumberPipe.prototype.transform = function (value, separator) {
        if (separator === void 0) { separator = ' '; }
        return this.addCardDigitsGroupSeparator(value, separator);
    };
    CreditCardNumberPipe.prototype.parse = function (value) {
        var text = value && value.toString();
        return text && text.length && text !== '' ? text.toString().replace(/\D/g, '') : '';
    };
    CreditCardNumberPipe.prototype.addCardDigitsGroupSeparator = function (value, thousandsSeparatorSymbol) {
        return this.reverseString(this.reverseString(value).replace(/\B(?=(\d{4})+(?!\d))/g, thousandsSeparatorSymbol));
    };
    CreditCardNumberPipe.prototype.reverseString = function (str) {
        return str.split('').reverse().join('');
    };
    return CreditCardNumberPipe;
}());
export { CreditCardNumberPipe };
